import { useCallback, useState } from 'react';
import { ScreenerResultSummary } from 'domains/signup/screener/Components/ScreenerResultsSummary';
import { loadScreenerResults } from 'domains/signup/screener/data/localStorage';
import { useNavigation } from 'utils/hooks/useNavigation';
import { ContentContainer } from 'components/ContentContainer';

const ScreenerResults: React.FC = () => {
  const [results] = useState(loadScreenerResults());
  const { routes, navigate } = useNavigation();

  const onProceedToSchedule = useCallback(() => {
    navigate(routes.signupDirect.base);
  }, [navigate, routes]);

  if (!results) {
    navigate(routes.screener.base);
    return null;
  }

  return (
    <ContentContainer variant="full">
      <div className="max-w-[600px] w-full self-center">
        <ScreenerResultSummary results={results} onProceedToSchedule={onProceedToSchedule} />
      </div>
    </ContentContainer>
  );
};

export default ScreenerResults;
